// Environment-specific configurations
const envConfigs = {
  development: {
    apiUrl: "http://localhost:8080",
    stripePublishableKey: 'pk_test_51RuZY5Dbi7kaG0ReoeSSWLAnh5emo0hMiRGNpFSzTVHqSPa3FVNyRSq5KeNXNnJhUKnntVUiyRDiQUlES1ZwzUTM00l06GaT7Y',
    wsUrl: "http://localhost:8080",
    googleClientId:
      "905378160983-331elj7nemh1lc5rkttt9spvoo1fanrs.apps.googleusercontent.com",
  },
    production: {
    apiUrl: "https://convert-603925667786.us-central1.run.app",
    stripePublishableKey: 'pk_live_IpGXF7WoreyOBw2KOiutFzuY00uOUGUxQI',
    wsUrl: "wss://convert-603925667786.us-central1.run.app",
    googleClientId:
      "905378160983-331elj7nemh1lc5rkttt9spvoo1fanrs.apps.googleusercontent.com",
  },
};

// Get current environment
const currentEnv = process.env.NODE_ENV || 'development';
console.log('Current environment:', currentEnv);

// WebSocket URL configuration
const config = {
    // Environment information
    env: currentEnv,
    
    // Core Configuration
    ...envConfigs[currentEnv],
    
    // Override with environment variables if they exist
    apiUrl: process.env.REACT_APP_API_URL || envConfigs[currentEnv].apiUrl,
    wsUrl: process.env.REACT_APP_WEBSOCKET_URL || envConfigs[currentEnv].wsUrl,
    googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || envConfigs[currentEnv].googleClientId,
    //apiUrl: 'https://25f0-2601-646-8280-1c60-b40a-bd1d-39e0-976.ngrok-free.app',
    //wsUrl: 'https://25f0-2601-646-8280-1c60-b40a-bd1d-39e0-976.ngrok-free.app',
    // Environment
    isDevelopment: process.env.NODE_ENV === 'development',
    isProduction: process.env.NODE_ENV === 'production',
    
    // Socket Configuration
    socketOptions: {
        path: '/socket.io',
        transports: ['websocket', 'polling'],
        reconnection: true,
        reconnectionAttempts: Infinity,  
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        timeout: 60000,  
        autoConnect: true,  
        withCredentials: true,
        forceNew: true,
        rejectUnauthorized: false,
        extraHeaders: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,OPTIONS',
            'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Google-Credentials'
        }
    },
    
    // Token Configuration
    tokenKey: 'auth_token',
    
    // API Endpoints
    endpoints: {
        auth: '/auth',
        verify: '/auth/verify',
        logout: '/auth/logout'
    },

    // Allowed Origins
    // Ensure env variable is defined to avoid runtime errors
    allowedOrigins: (process.env.REACT_APP_ALLOWED_ORIGINS || '')
        .split(',')
        .map(origin => origin.trim())
        .filter(Boolean)



};

// Log configuration on load
console.log('Loaded configuration:', config);

export default config;
